import type { Language } from '@seek/melways-sites';

const defaultSiteDescription =
  'Manage your SEEK account settings, including email and notification settings.';

const siteDescriptions: Record<string, string> = {
  'candidate-seek-au-en':
    'Manage your SEEK account settings, including email and notification settings.',
  'candidate-seek-nz-en':
    'Manage your SEEK account settings, including email and notification settings.',
  'candidate-jobsdb-hk-en':
    'Manage your Jobsdb account settings, including email and notification settings.',
  'candidate-jobsdb-hk-zh':
    'Manage your Jobsdb account settings, including email and notification settings.',
  'candidate-jobsdb-th-en':
    'Manage your Jobsdb account settings, including email and notification settings.',
  'candidate-jobsdb-th-th':
    'จัดการการตั้งค่าบัญชี Jobsdb ของคุณ รวมถึงอีเมลและการแจ้งเตือน',
  'candidate-jobstreet-sg-en':
    'Manage your Jobstreet account settings, including email and notification settings.',
  'candidate-jobstreet-id-en':
    'Manage your Jobstreet account settings, including email and notification settings.',
  'candidate-jobstreet-id-id':
    'Kelola pengaturan akun Jobstreetmu, termasuk email, dan notifikasi.',
  'candidate-jobstreet-ph-en':
    'Manage your Jobstreet account settings, including email and notification settings.',
  'candidate-jobstreet-my-en':
    'Manage your Jobstreet account settings, including email and notification settings.',
  'candidate-au-en':
    'Manage your SEEK account settings, including email and notification settings.',
  'candidate-nz-en':
    'Manage your SEEK account settings, including email and notification settings.',
  'candidate-hk-en':
    'Manage your JobsDB account settings, including email and notification settings.',
  'candidate-hk-zh':
    'Manage your JobsDB account settings, including email and notification settings.',
  'candidate-th-en':
    'Manage your JobsDB account settings, including email and notification settings.',
  'candidate-th-th':
    'จัดการการตั้งค่าบัญชี Jobsdb ของคุณ รวมถึงอีเมลและการแจ้งเตือน',
  'candidate-sg-en':
    'Manage your Jobstreet account settings, including email and notification settings.',
  'candidate-id-en':
    'Manage your Jobstreet account settings, including email and notification settings.',
  'candidate-id-id':
    'Kelola pengaturan akun Jobstreetmu, termasuk email, dan notifikasi.',
  'candidate-ph-en':
    'Manage your Jobstreet account settings, including email and notification settings.',
  'candidate-my-en':
    'Manage your Jobstreet account settings, including email and notification settings.',
};

export default (
  site: string = 'candidate-seek-au',
  language: Language = 'en',
): string => siteDescriptions[`${site}-${language}`] || defaultSiteDescription;
